export default __webpack_public_path__ + "static/media/node-card-device.3a4dadc3.png";